<template>
  <div class="relationalDatabaseServiceResourceSearch">
    <Row :gutter="4" style="margin-bottom: 10px;">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="5">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
    </Row>
    <Row :gutter="4">
      <Col span="4">
        <Input
          v-model="accountNameSearchKey"
          :placeholder="$t('RAM.common.filterByAccountName')"
        />
      </Col>
      <Col span="4">
        <Input
          v-model="nameSearchKey"
          :placeholder="$t('RAM.common.QuerybyInstanceName')"
        />
      </Col>
      <Col span="4">
        <Input
          v-model="engineSearchKey"
          :placeholder="$t('RAM.common.SearchbyEngine')"
        />
      </Col>
      <Col span="4">
        <Input
          v-model="typeSearchKey"
          :placeholder="$t('RAM.common.QuerybyInstanceType')"
        />
      </Col>
      <Col span="4">
        <Select
          v-model="state"
          filterable
          :placeholder="$t('RAM.common.FilterbyOperatingStatus')"
          :transfer="true"
        >
          <Option value="" v-if="stateNameList.length > 0">{{
            $t("configuration_management.common.cloudType")
          }}</Option>
          <Option
            :value="item.id"
            v-for="item in stateNameList"
            :key="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </Col>
      <Col span="4">
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:relationalDatabaseServiceResource:page'
          ]"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../utils/cookieUtil.js";
import TableRelationalDatabaseServiceResource from "../rds/TableRelationalDatabaseServiceResource";

var tableRelationalDatabaseServiceResource = TableRelationalDatabaseServiceResource;
export default {
  name: "RelationalDatabaseServiceResourceSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      accountNameSearchKey: "",
      nameSearchKey: "",
      engineSearchKey: "",
      typeSearchKey: "",
      state: "",
      stateNameList: [
        {
          id: 0,
          name: "creating"
        },
        {
          id: 1,
          name: "available"
        },
        {
          id: 2,
          name: "stopping"
        },
        {
          id: 3,
          name: "stopped"
        },
        {
          id: 4,
          name: "shutting down"
        },
        {
          id: 5,
          name: "terminated"
        }
      ]
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountNameSearchKey", this.accountNameSearchKey);
      eventBus.$emit("nameSearchKey", this.nameSearchKey);
      eventBus.$emit("engineSearchKey", this.engineSearchKey);
      eventBus.$emit("typeSearchKey", this.typeSearchKey);
      eventBus.$emit("state", this.state);
      tableRelationalDatabaseServiceResource.methods.showAll();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    }
  }
};
</script>
<style scoped>
.relationalDatabaseServiceResourceSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/rds/RelationalDatabaseServiceResourceSearch.vue